// import React from "react";
import {
  FaFacebookF,
  FaYoutube,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-green-700 text-white pt-10 pb-6 px-6">
      <div className="max-w-90vw font-sans mx-auto">
        <div className="flex flex-col md:flex-row justify-between gap-12 flex-wrap mb-10">
          {/* Contact Section */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact</h3>
            <p className="mb-4">
              <span className="font-semibold font-sans">Email:</span>{" "}
              help@surveysiq.com
            </p>
            <h4 className="text-md font-sans font-semibold mb-2">
              Get In Touch
            </h4>
            <div className="flex gap-4 text-2xl">
              <a
                href="https://www.facebook.com/Surveysiq"
                className="hover:text-gray-300"
              >
                <FaFacebookF />
              </a>
              {/* <a href="#" className="hover:text-gray-300">
                <FaTwitter />
              </a> */}
              {/* <a
                href="https://www.youtube.com/@surveysiq"
                className="hover:text-gray-300"
              >
                <FaYoutube />
              </a> */}
              {/* <a
                href="https://www.instagram.com/surveysiqs/"
                className="hover:text-gray-300"
              >
                <FaInstagram />
              </a> */}
              {/* <a href="#" className="hover:text-gray-300">
                <FaTelegramPlane />
              </a> */}
              <a
                href="https://api.whatsapp.com/send/?phone=917219770092&text"
                className="hover:text-gray-300"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="font-sans">
            <h3 className="text-lg font-bold font-sans mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://surveysiq.com/terms-conditions"
                  className="hover:text-gray-300"
                >
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a
                  href="https://surveysiq.com/privacy-policy"
                  className="hover:text-gray-300"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="https://surveysiq.com/refund-policy"
                  className="hover:text-gray-300"
                >
                  Refund Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Address */}
          <div>
            <h3 className="text-lg font-bold mb-4">Address</h3>
            <p className="mb-2">
              C2 - Manik Chembar, Near - Janta bazar chowk,
            </p>
            <p className="mb-2">Rajarampuri, Kolhapur, Pin - 416008</p>

            <p>
              <span className="font-semibold">Mobile:</span> 7219770092
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center border-t border-gray-600 pt-4 text-sm">
          <div className="flex justify-center items-center gap-2 flex-col">
            {/* <span className="text-sm">
              {" "}
              Powered by Techaircraft Solution Pvt. Ltd.
            </span>
            <span className="text-sm">
              {" "}
              Copyright © 2025 Techaircraft Solution Pvt. Ltd. All
              rights reserved.
            </span> */}
            <span>
              {" "}
              SurveysIQ is owned and operated by TECHAIRCRAFT SOLUTION PRIVATE LIMITED.
            </span>
            { <span>
              {" "}
              © 2026 All rights reserved.
            </span> }
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
